{
  "CHAT_LIST": {
    "LOADING": "جاري جلب المحادثات",
    "LOAD_MORE_CONVERSATIONS": "تحميل المزيد من المحادثات",
    "EOF": "تم تحميل كافة المحادثات 🎉",
    "LIST": {
      "404": "لا توجد محادثات نشطة في هذه المجموعة."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "المحادثات",
    "MENTION_HEADING": "الإشارات",
    "UNATTENDED_HEADING": "بدون حضور",
    "SEARCH": {
      "INPUT": "البحث عن جهات الاتصال، المحادثات، قوالب الردود الجاهزة .."
    },
    "SEARCH_MESSAGES": "البحث في المحادثات",
    "SEARCH_INPUT_PLACEHOLDER": "ابحث في المحادثات...",
    "FILTER_ALL": "الكل",
    "ASSIGNEE_TYPE_TABS": {
      "me": "محادثاتي",
      "unassigned": "غير معيّن",
      "all": "الكل"
    },
    "MESSAGE_USE_AS_TEMPLATE": "إدراج في الرد",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "فتح",
        "BUY": "شراء"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "فتح"
      },
      "resolved": {
        "TEXT": "تم حلها"
      },
      "pending": {
        "TEXT": "معلق"
      },
      "snoozed": {
        "TEXT": "مؤجلة"
      },
      "all": {
        "TEXT": "الكل"
      }
    },
    "VIEW_FILTER": "عرض",
    "SORT_TOOLTIP_LABEL": "ترتيب المحادثات",
    "CHAT_SORT": {
      "STATUS": "الحالة",
      "ORDER_BY": "الترتيب بواسطة"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "مضاف",
      "LAST_ACTIVITY": "آخر نشاط:",
      "LAST_CUSTOMER_MESSAGE": "آخر رسالة من العميل:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "آخر نشاط: الأقدم أولا"
      },
      "last_activity_at_desc": {
        "TEXT": "آخر نشاط: الأحدث أولا"
      },
      "last_customer_message_at_asc": {
        "TEXT": "آخر رسالة من العميل: الأقدم أولاً"
      },
      "last_customer_message_at_desc": {
        "TEXT": "آخر رسالة من العميل: الأحدث أولاً"
      },
      "created_at_desc": {
        "TEXT": "وقت الإنشاء: الأحدث أولاً"
      },
      "created_at_asc": {
        "TEXT": "وقت الإنشاء: الأقدم أولاً"
      },
      "priority_desc": {
        "TEXT": "الأولوية: الأعلى أولا"
      },
      "priority_asc": {
        "TEXT": "الأولوية: الأقل أولاً"
      },
      "priority_created_at_desc": {
        "TEXT": "الأولوية + وقت الإنشاء: الأحدث أولاً"
      },
      "priority_created_at_asc": {
        "TEXT": "الأولوية + وقت الإنشاء: الأقدم أولاً"
      },
      "waiting_since_asc": {
        "TEXT": "الرد المعلق: الأطول أولا"
      },
      "waiting_since_desc": {
        "TEXT": "الرد المعلق: الأقصر أولاً"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "رسالة صورة"
      },
      "audio": {
        "CONTENT": "رسالة صوتية"
      },
      "video": {
        "CONTENT": "رسالة فيديو"
      },
      "file": {
        "CONTENT": "مرفقات"
      },
      "location": {
        "CONTENT": "الموقع الجغرافي"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "قام بمشاركة رابط"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "ترتيب المحادثات",
      "DROPDOWN_TITLE": "ترتيب حسب",
      "ITEMS": {
        "LATEST": {
          "NAME": "آخر نشاط في",
          "LABEL": "آخر نشاط"
        },
        "CREATED_AT": {
          "NAME": "تم إنشاؤها في",
          "LABEL": "تم إنشاؤها في"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "آخر رسالة للمستخدم في",
          "LABEL": "أخر رسالة"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "تم تلقيه عبر البريد الإلكتروني",
    "VIEW_TWEET_IN_TWITTER": "عرض التغريدة في تويتر",
    "REPLY_TO_TWEET": "الرد على هذه التغريدة",
    "LINK_TO_STORY": "الذهاب إلى قصة الإنستقرام",
    "SENT": "تم الإرسال بنجاح",
    "READ": "تمت القراءة بنجاح",
    "DELIVERED": "تم الإرسال بنجاح",
    "NO_MESSAGES": "لا توجد رسائل",
    "NO_CONTENT": "لم يتم العثور على محتوى",
    "HIDE_QUOTED_TEXT": "إخفاء النص المقتبس",
    "SHOW_QUOTED_TEXT": "إظهار النص المقتبس",
    "HIDE_AUTOMATED_MESSAGE": "إخفاء محتوى الرد التلقائي",
    "SHOW_AUTOMATED_MESSAGE": "إظهار محتوى الرد التلقائي",
    "AUTOMATED_MESSAGE": "رد تلقائي",
    "MESSAGE_READ": "قراءة",
    "SENDING": "Sending"
  }
}
